import React from 'react'
import styles from './invalid-link.styles'
import injectSheet from 'react-jss'
import Container from '../components/container/container'
import Title from '../components/title/title'
import Description from '../components/description/description'
import duckConfused from './duck-confused.gif'

const InvalidLink = ({ classes }) => (
  <Container>
    <img className={classes.img} src={duckConfused} alt="Invalid link" />
    <Title>Hm...</Title>
    <Description>
      <p>Sorry, that link is invalid</p>
      <p>
        If you have any questions, please contact{' '}
        <a href="mailto:hello@pobble.com">hello@pobble.com</a>
      </p>
    </Description>
  </Container>
)

export default injectSheet(styles)(InvalidLink)
